export default {"src":"/_next/static/media/team.af2f7e9a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};